import type { ReactNode } from 'react'
import { cn } from '@lib/cn'

interface GlassCardProps {
  children: ReactNode
  className?: string
  hover?: boolean
}

export function GlassCard({
  children,
  className,
  hover = false,
}: GlassCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl shadow-xl backdrop-blur-md transition-colors duration-200 overflow-hidden',
        'bg-[var(--glass-bg)] border border-[var(--glass-border)]',
        hover && 'hover:bg-[var(--glass-bg)]/90 hover:border-[var(--color-border)]',
        className
      )}
    >
      {children}
    </div>
  )
}
